module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/181-trinidad-and-tobago-2668d7acec2bb645a54251bb6fb5fbe1.svg";